import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SummaryFeedbackDialog from '../demo/SummaryFeedbackDialog';

class SummaryControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }

        this.feedbackDisable = window._feedbackDisable;
    }

    componentDidMount() {
    }

    render() {
        return(
            <div className="summarycontrol-wrapper">
                <div>
                    <div className="toolbar-container">
                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onReset}>
                            <span className='fa fa-undo'></span>&nbsp;Reset
                        </button>
                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onEdit}>
                            <span className='fa fa-edit'></span>&nbsp;Edit
                        </button>
                        {!this.feedbackDisable &&
                            <div style={{marginRight:'15px'}}>
                                <SummaryFeedbackDialog text={this.props.text} results={this.props.summary ? this.props.summary : {}}/>
                            </div>
                        }
                    </div>
                    {(this.props.summary && this.props.summary.summary) &&
                        <div className="summary-results">
                            <div className='header'>Summary:</div>
                            <span className="summary-results-text">
                                {this.props.summary.summary}
                            </span>
                        </div>
                    }
                    {(this.props.summary && this.props.summary.summarySentences) &&
                        <div className="summary-results">
                            <div className='header'>Summary Sentences:</div>
                            <span className="summary-results-text">
                                <div className="bullet-list">
                                    <ul className="toc-level list-wrapper">
                                    {this.props.summary.summarySentences.map((sentence, index) => {
                                        return (<li key={index} className="list-item summary-list-item">{sentence}</li>);
                                    })}  
                                    </ul>
                                </div>
                            </span>
                        </div>
                    }
                    <div className="summary-text">
                        <br/>
                        <div className='header'>Original Text:</div>
                        <div style={{whiteSpace: 'pre-line'}}>
                            {this.props.text}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

SummaryControl.propTypes = {
    text: PropTypes.string.isRequired,
    summary: PropTypes.object,
    onReset: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired
};

export default SummaryControl;

